import { API } from 'constants/api-endpoints';

import { tokenInstance } from 'lib/axios/instance';

export const fetchMatchedAvatar = async (id) => {
  const { data } = await tokenInstance.get(`${API.TEAM_MANAGERS}/match/${id}`);
  return data;
};
